<template>
  <v-combobox
    v-model="selectedItems"
    :filter="filter"
    :hide-no-data="!search"
    :items="items"
    :search-input.sync="search" hide-selected
    :label="label"
    multiple
    :small-chips="smallChips"
  >
    <template v-slot:no-data>
      <v-list-item @click="createFromList">
        <span class="subheading">Create &nbsp;</span>
        <v-chip
          small
        >
          {{ search }}
        </v-chip>
      </v-list-item>
    </template>
    <template v-slot:selection="{ attrs, item, parent, selected }">
      <v-chip
        v-if="item === Object(item)"
        v-bind="attrs"
        :input-value="selected"
        small
      >
        <span class="pr-2">
          {{ item.text }}
        </span>
        <v-icon
          small
          @click="parent.selectItem(item)"
        >mdi-close-circle</v-icon>
      </v-chip>
    </template>
    <template v-slot:item="{ index, item }">
      <v-text-field
        v-if="editing === item"
        v-model="editing.text"
        autofocus
        flat
        background-color="transparent"
        hide-details
        @keyup.enter="edit(index, item)"
      ></v-text-field>
      <v-chip
        v-else
        small
      >
        {{ item.text }}
      </v-chip>
      <v-spacer></v-spacer>
      <v-list-item-action @click.stop>
        <v-btn
          icon
          @click.stop.prevent="edit(index, item)"
        >
          <v-icon>{{ editing !== item ? 'mdi-pencil' : 'mdi-check' }}</v-icon>
        </v-btn>
      </v-list-item-action>
    </template>
  </v-combobox>
</template>

<script>
import { isNil } from 'ramda'

export default {
  name: 'dynamic-combobox',
  props: {
    initialItems: {
      type: Array,
      required: false,
      default: () => {}
    },
    value: {
      type: Array,
      required: false
    },
    label: {
      type: String,
      required: false,
      default: 'Search for an email'
    },
    smallChips: {
      type: Boolean,
      required: false,
      default: true
    },
    solo: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: () => ({
    editing: null,
    index: -1,
    items: [
      { header: 'Select existing or create new' }
    ],
    search: null
  }),
  computed: {
    selectedItems: {
      get () {
        if (!Array.isArray(this.value)) {
          return []
        } else {
          return this.value.map(item => {
            return { text: item }
          })
        }
      },
      set (val) {
        const emitVal = val.map(item => {
          // manually set item
          if (typeof item === 'string') {
            return item
          } else {
            return item.text
          }
        })

        // add new items to the list of items...
        emitVal.forEach(item => {
          const matchedItem = this.items.find(existingItem => item === existingItem.text)
          if (isNil(matchedItem)) {
            this.items.push({ text: item })
          }
        })

        // notify parent component
        this.$emit('input', emitVal)
      }
    }
  },

  watch: {
    initialItems: {
      immediate: true,
      handler (newVal) {
        if (newVal && newVal.length > 0) {
          newVal.forEach(email => this.items.push({ text: email }))
        }
      }
    }
  },

  methods: {
    createFromList (event) {
      this.selectedItems = [...this.selectedItems, event.target.valueOf().textContent.trim()]
      this.search = ''
    },
    edit (index, item) {
      if (!this.editing) {
        this.editing = item
        this.index = index
      } else {
        this.editing = null
        this.index = -1
      }
    },
    filter (item, queryText, itemText) {
      if (item.header) return false

      const hasValue = val => val != null ? val : ''

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString()
        .toLowerCase()
        .indexOf(query.toString().toLowerCase()) > -1
    }
  }
}
</script>
